/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * TILLFÄLLIG FIX: SEK-priser visas inte på produktsidor.
   *
   * Shopify Markets tvingar formatet {{amount_with_space_separator}} för SEK.
   * Temats formatMoney (vendor.js) saknar stöd för det formatet och returnerar
   * tom sträng, vilket gör att JS skriver över det korrekta Liquid-priset med
   * bara valutakoden. Funktionen är skrivskyddad och går inte att patcha.
   *
   * Denna fix läser priset från produkt-JSON och skriver in det direkt.
   * TA BORT efter temauppdatering – buggen är åtgärdad i nyare version.
   */
  if (document.documentElement.lang !== 'sv') return;

  var formatSEK = function(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    return whole + ',' + parts[1] + ' SEK';
  };

  var getVariant = function(product) {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (id) {
      var match = product.variants.find(function(v) {
        return String(v.id) === id;
      });
      if (match) return match;
    }
    var selected = document.querySelector('[name="id"]');
    if (selected && selected.value) {
      var byInput = product.variants.find(function(v) {
        return String(v.id) === selected.value;
      });
      if (byInput) return byInput;
    }
    return product.variants[0];
  };

  var renderPrice = function() {
    var json = document.querySelector('[data-product-json]');
    if (!json || !json.innerHTML.trim()) return;

    var product;
    try {
      product = JSON.parse(json.innerHTML);
    } catch (e) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    var variant = getVariant(product);
    if (!variant) return;

    var sale = document.querySelector('[data-product-price]');
    var strike = document.querySelector('[data-compare-price]');

    if (sale) {
      sale.textContent = formatSEK(variant.price);
    }
    if (strike) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        strike.textContent = formatSEK(variant.compare_at_price);
      } else {
        strike.textContent = '';
      }
    }
  };

  var init = function() {
    renderPrice();
    setTimeout(renderPrice, 300);

    // Uppdatera priset när kunden byter variant
    document.querySelectorAll('[name^="options"], [name="id"]').forEach(function(el) {
      el.addEventListener('change', function() {
        setTimeout(renderPrice, 50);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();